import $ from 'jquery';

const toggleDropdown = (el) => {
  $(el).toggleClass('active').find('.svg-inline--fa').toggleClass('fa-plus').toggleClass('fa-minus');
  $('.translate__dropdown').slideToggle();
}

$(document).on('click', '.translate__toggle', function() {
  toggleDropdown($(this));
});
